import * as React from 'react';
import { ClearButton } from '../../../../components/button/ClearButton';
import { InvoiceStatus } from '../../../../models/accounting/enums/invoice-status';
import { InvoiceTypeMetadata } from '../../../../models/accounting/enums/invoice-type';
import { InvoiceRead } from '../../../../models/accounting/shared/invoice-read';
import { formatCurrency } from '../../../../utils/currency-formatter';

const InvoiceRow = (props: {invoice : InvoiceRead, downloadAction : any, summaryDownloadAction : any }) => (
    <tr>
        <td>
            {
                props.invoice.status === InvoiceStatus.Published 
                ? <i title="Published to AccountMate" 
                className="invoice-status published" /> 
                : <i title="Pending" 
                    className="invoice-status pending" /> 
            }
        </td>
        <td>{ props.invoice.invoiceNumber }</td>
        <td>{ InvoiceTypeMetadata[props.invoice.type].display }</td>
        <td>{ props.invoice.invoiceDate.toLocaleDateString() }</td>
        <td>{ `${ props.invoice.dealerName } [${props.invoice.dealerId}]` }</td>
        <td>{ formatCurrency(props.invoice.total.foreign) }</td> 
        <td className="action-cell-icons">
            <ClearButton
                id={'invoicerow-' + props.invoice.id }
                text="Invoice"
                classes="action"
                onBtnClick={ () => props.downloadAction(props.invoice.id, props.invoice.invoiceNumber) }
                icon="la-file-pdf-o" />
            {
                props.invoice.groupId && props.invoice.groupId.length > 0
                ? <ClearButton
                    id={'invoicegrouprow-' + props.invoice.id }
                    text="Summary"
                    classes="action"
                    onBtnClick={ () => props.summaryDownloadAction(props.invoice.id, props.invoice.invoiceNumber) }
                    icon="la-file-pdf-o" /> 
                : null
            }
        </td>
    </tr>
);

export { InvoiceRow };
